import { WalletStatus, useWallet } from "@terra-money/wallet-provider";
import ConnectItem from "../ConnectItem";
import { useContext, useEffect, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import { ModalContext } from "@contexts/ModalContext";
import useModal from "@hooks/ModalHook";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { openModal } from "@hooks/HelperHook";

function WalletModal() {

    const wallet = useWallet();

    const { showModal, closeModal, modalId } = useModal()

    useEffect(() => {
        if (wallet.status == WalletStatus.WALLET_CONNECTED) {
            if (showModal) closeModal()
        } else if (wallet.status == WalletStatus.WALLET_NOT_CONNECTED) {
            openModal("wallet")
        }
    }, [wallet.status])

    return <>
        <Modal show={showModal && modalId === "wallet"} onHide={() => closeModal()} dialogClassName="max-w-lg">
            <Modal.Header>
                <Modal.Title>Connect your wallet</Modal.Title>
                <button type="button" className="btn-close" onClick={() => closeModal()} aria-label="Close">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="h-6 w-6 fill-jacarta-700 dark:fill-white"
                    >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                            d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
                        />
                    </svg>
                </button>
            </Modal.Header>
            <Modal.Body className="p-6 text-center grid grid-cols-1 gap-3">
                {wallet.availableConnections.map((value, index) => {
                    return <ConnectItem
                        key={index}
                        name={value.name}
                        description={"Connect using this method"}
                        icon={value.icon}
                        onConnect={async () => {
                            wallet.connect(value.type, value.identifier)
                            closeModal()
                        }}
                    />
                })}
            </Modal.Body>
        </Modal>
    </>
}

export default WalletModal;